<template>
  <!-- 源语言 -->
  <language-unit
    :language="srcLanguage"
    :disLang="tarLanguage"
    :isPre="isPre"
    :size="size"
    :type="type"
    @change="changeSrc"
  ></language-unit>
  <svg
    aria-hidden="true"
    class="change-icon"
    style="width: 16px; height: 16px"
    @click="toggle"
    v-if="srcLanguage && tarLanguage"
  >
    <use xlink:href="#icon-jiaohuan"></use>
  </svg>
  <svg
    aria-hidden="true"
    class="change-icon cursor-not-allowed"
    style="width: 16px; height: 16px"
    v-else
  >
    <use xlink:href="#icon-jiaohuan"></use>
  </svg>
  <!-- 目标语言 -->
  <language-unit
    :language="tarLanguage"
    :disLang="srcLanguage"
    :isPre="isPre"
    :size="size"
    :type="type"
    from="tar"
    @change="changeTar"
  ></language-unit>
</template>
<script>
  import { ref, reactive, toRefs, onMounted, computed } from 'vue'
  import LanguageUnit from './LanguageUnit.vue'
  export default {
    components: { LanguageUnit },
    emits: ['change'],
    props: {
      type: {
        default: '',
      },
    },
    setup(props, ctx) {
      const state = reactive({
        srcLanguage: undefined,
        tarLanguage: props.type == 'img' ? undefined : 2,
        isPre: false,
        size: 'large',
      })

      // 获取源语言
      const changeSrc = (id) => {
        state.srcLanguage = id
        changeTs()
      }
      // 触发父组件方法
      const changeTs = () => {
        ctx.emit('change', {
          srcLanguage: state.srcLanguage,
          tarLanguage: state.tarLanguage,
        })
      }
      // 获取目标语言
      const changeTar = (id) => {
        state.tarLanguage = id
        changeTs()
      }

      // 切换语言
      const toggle = () => {
        let newTarLanguage = state.srcLanguage
        state.srcLanguage = state.tarLanguage
        state.tarLanguage = newTarLanguage
        changeTs()
      }
      return {
        ...toRefs(state),
        changeSrc,
        changeTar,
        toggle,
        changeTs,
      }
    },
  }
</script>
<style lang="scss">
  .language-change {
    width: 40px;
    height: 40px;
    padding: 12px;
    cursor: pointer;
  }
  .change-icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    cursor: pointer;
    margin: 0 20px;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
</style>
